
export const globalTranslateCapitalizationStatus = (status: string = ""): string => {
    const s = status.toLowerCase();
    if (s === "issuing") return "Em emissão";
    if (s === "issued") return "Título emitido";
    if (s === "awaiting_payment") return "Aguardando pagamento";
    if (s === "pending") return "Com pendências";
    if (s === "canceled") return "Cancelado";
    if (s === "redemption_requested") return "Resgate solicitado";
    if (s === "redemption_completed") return "Resgate concluído";
    return status;
};

export const globalTranslateMaritalStatusCapitalization = (status: string = ""): string => {
    const s = status.toLowerCase();
    if (s === "single") return "Solteiro";
    if (s === "married") return "Casado";
    if (s === "widower") return "Viúvo";
    if (s === "divorced") return "Divorciado";
    if (s === "stable_union") return "União Estável";
    return status;
};
